import { StyleRoot } from "@redotech/react-util/style";
import { defaultBrandKit } from "@redotech/redo-model/brand-kit";
import { createDefaultLoyaltyPageSettings } from "@redotech/redo-model/loyalty/loyalty-page-builder/defaults";
import { LOYALTY_PAGE_MAX_WIDTH } from "@redotech/redo-model/loyalty/loyalty-page-builder/definition";
import { Flex } from "@redotech/redo-web/flex";
import { BlockContent } from "@redotech/redo-web/loyalty-page-builder/blocks/index";
import {
  LoyaltyPageContext,
  LoyaltyPageEnvironment,
} from "@redotech/redo-web/loyalty-page-builder/context/loyalty-page-context";
import { createRoot } from "react-dom/client";
import { RedoShopifyRpcClientContextProvider } from "../client/redo-shopify-rpc-client";
import { log } from "../monitoring/log";
import { RedoRoot } from "../root";
import STYLE_MANAGER from "../style-manager";

export function initialize(autocheck: any) {
  log("Initializing Loyalty page customer view");

  const container = document.getElementById("redo-loyalty-page");
  if (!container) {
    log("No loyalty page container found");
    return;
  }

  log("Found Loyalty page container");

  // Shopify applies display: none to empty divs
  container.style.display = "unset";

  const root = createRoot(container);
  root.render(
    <StyleRoot container={container} styleManager={STYLE_MANAGER}>
      <RedoRoot
        extensionShopifyClient={undefined}
        storeUrl={
          globalThis.redoStorefront?.storeUrl ??
          globalThis.Shopify?.shop ??
          globalThis.Shopify?.Checkout?.apiHost
        }
      >
        <RedoShopifyRpcClientContextProvider
          baseUrl={
            globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
            process.env.REDO_SHOPIFY_SERVER_URL!
          }
          storeUrl={
            globalThis.Shopify?.shop ?? globalThis.Shopify?.Checkout?.apiHost
          }
          widgetId={globalThis.redoWidgetId}
        >
          <RedoLoyaltyPageCustomerView autocheck={autocheck} />
        </RedoShopifyRpcClientContextProvider>
      </RedoRoot>
    </StyleRoot>,
  );
}

function RedoLoyaltyPageCustomerView({ autocheck }: { autocheck: any }) {
  // TODO: actually fetch customer data
  const customer = null;

  // TODO: actually fetch from server
  const settings = createDefaultLoyaltyPageSettings();

  // TODO: actually use brand kit on team
  const brandKit = defaultBrandKit;

  return (
    <LoyaltyPageContext.Provider
      value={{
        environment: LoyaltyPageEnvironment.STOREFRONT,
        customer,
        pageSettings: settings,
        teamSettings: { brandKit },
      }}
    >
      <Flex
        bgColor="primary"
        dir="column"
        gap="none"
        style={{
          width: LOYALTY_PAGE_MAX_WIDTH,
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        {settings.blocks.map((block, index) => (
          <BlockContent block={block} key={block.id || index} />
        ))}
      </Flex>
    </LoyaltyPageContext.Provider>
  );
}
